import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import {
  PointFilterEnum,
  PointDetailsQueryEnum
} from '@points/definitions/enums'
import { type PointType } from '@points/definitions/models'

import { queryController } from '@composables/queryController'

export const usePointsQueryStore = defineStore('usePointsQueryStore', () => {
  const route = useRoute()
  const { getQueryString } = queryController()

  const getInitialState = () => ({
    [PointFilterEnum.status]: getQueryString(route.query, PointFilterEnum.status),
    [PointFilterEnum.name]: getQueryString(route.query, PointFilterEnum.name)
  })

  const getDetailsState = () => ({
    [PointDetailsQueryEnum.point_id]: getQueryString(route.query, PointDetailsQueryEnum.point_id)
  })

  const pointsState = ref(getInitialState())
  const pointDetailsState = ref(getDetailsState())

  const updatePointStateQuery = (vals: Partial<typeof pointsState.value>) => {
    pointsState.value = Object.assign(pointsState.value, vals)
  }

  const setPointDetailsQuery = (point?: PointType) => {
    pointDetailsState.value[PointDetailsQueryEnum.point_id] = point ? point.code : ''
  }

  const clearPointsState = () => {
    pointsState.value = {
      [PointFilterEnum.status]: '',
      [PointFilterEnum.name]: ''
    }
  }

  const clearPointsStateDetails = () => {
    pointDetailsState.value = {
      [PointDetailsQueryEnum.point_id]: ''
    }
  }

  const clearPointsStateByKeys = (keyList: PointFilterEnum[]) => {
    keyList.forEach(key => {
      pointsState.value[key] = ''
    })
  }

  return {
    pointsState,
    pointDetailsState,
    updatePointStateQuery,
    setPointDetailsQuery,
    clearPointsState,
    clearPointsStateDetails,
    clearPointsStateByKeys
  }
})
